import { render, staticRenderFns } from "./lookLogisticsDialog1.vue?vue&type=template&id=4b7e9d54&scoped=true&"
import script from "./lookLogisticsDialog1.vue?vue&type=script&lang=js&"
export * from "./lookLogisticsDialog1.vue?vue&type=script&lang=js&"
import style0 from "./lookLogisticsDialog1.vue?vue&type=style&index=0&id=4b7e9d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e9d54",
  null
  
)

export default component.exports